import { useEffect } from 'react';
import { ensureLocalDataMatchesAuthUser, isDatabaseUnavailableError } from '../../shared/localDb';
import { clearExpiredCache } from '../../auth/infra/branches/branchesCache';
import { devWarn } from '../../shared/dev/devLog';
import { captureCatch } from '../../shared/sentry/sentryUser';

/**
 * Priming de datos locales al loguear: asegura que la DB local corresponda
 * al usuario autenticado (wipe si cambió de cuenta) y limpia caché de
 * sucursales expirado. Fire-and-forget — no retorna estado.
 */
export function useLocalDataPrimer(userId: string | undefined): void {
  useEffect(() => {
    if (!userId) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await ensureLocalDataMatchesAuthUser(userId);
        if (cancelled) return;
        // Limpiar caché de sucursales expirado al iniciar la app
        await clearExpiredCache().catch(captureCatch('shell', 'local-data-primer-clear-expired-cache'));
      } catch (error) {
        if (!isDatabaseUnavailableError(error)) {
          devWarn('[App] Datos locales / categorías al iniciar', error);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);
}
